let ajaxUrl = document.body?.dataset?.ajaxurl ?? '';

if (typeof silkApiWp !== 'undefined') {
	ajaxUrl = silkApiWp.ajaxUrl;
}

import './booking';
